import { render, staticRenderFns } from "./PaymentMethodSummary.vue?vue&type=template&id=00428f02&scoped=true&"
import script from "./PaymentMethodSummary.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodSummary.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodSummary.vue?vue&type=style&index=0&id=00428f02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00428f02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VIcon,VSwitch})
